import React from 'react';

const SvgVe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="VE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="VE_svg__b" fill="#fff">
        <use xlinkHref="#VE_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#VE_svg__a" />
      <path fill="#063191" mask="url(#VE_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#E2213B" mask="url(#VE_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M14 9.333A.667.667 0 1 1 14 8a.667.667 0 0 1 0 1.333zM11.333 10a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm5.334 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM10 12a.667.667 0 1 1 0-1.333A.667.667 0 0 1 10 12zm8 0a.667.667 0 1 1 0-1.333A.667.667 0 0 1 18 12z"
        fill="#FFF"
        mask="url(#VE_svg__b)"
      />
      <path fill="#FFD044" mask="url(#VE_svg__b)" d="M0 0h28v6.667H0z" />
    </g>
  </svg>
);

export default SvgVe;
